module.exports = __webpack_public_path__ + "img/shield-grey.0b85a936.svg";